import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Swal from "sweetalert2";
import axiosInstance from "../services/axiosInterceptor";
import Header from "../layouts/Header";
import ClubAttendanceStats from "./ClubAttendanceStats";

// หน้าสถิติการเข้าชุมนุมของหัวหน้าวิชาการสามัญ (pos 3/4) — ใช้แท็บเดียวกับหน้าจัดการชุมนุม
// แต่ไม่มีเมนูจัดการอื่น เพราะหัวหน้าวิชาการดูได้อย่างเดียว (server คุมด้วย canViewStats / canViewClub)
export default function ClubAttendanceReport() {
  const [years, setYears] = useState([]);
  const [yearId, setYearId] = useState("");

  useEffect(() => {
    axiosInstance.get("/api/clubs/references")
      .then(({ data }) => {
        const stored = localStorage.getItem("yearId");
        const selected = data.years.find(y => String(y.year_id) === String(stored)) || data.years[0];
        setYears(data.years);
        if (selected) setYearId(String(selected.year_id));
      })
      .catch(() => Swal.fire("ผิดพลาด", "โหลดปีการศึกษาไม่สำเร็จ", "error"));
  }, []);

  const selectedYear = years.find(y => String(y.year_id) === String(yearId));

  return (
    <>
      <Header />
      <main className="main main-app p-3 p-lg-4">
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-4">
          <div>
            <h4 className="main-title mb-1">สถิติการเข้าชุมนุม</h4>
            <div className="text-secondary">อัตรามาเรียนและการเช็คชื่อของทุกชุมนุม (อ่านอย่างเดียว)</div>
          </div>
          <Form.Select value={yearId} onChange={e => setYearId(e.target.value)} style={{ width: 190 }}>
            {years.map(year => <option key={year.year_id} value={year.year_id}>ปีการศึกษา {year.year_year}</option>)}
          </Form.Select>
        </div>
        <ClubAttendanceStats yearId={yearId} year={selectedYear} />
      </main>
    </>
  );
}
